import React from "react"

type Props = {
	className: string
}

const DreamBrokerLogoWhiteSimple = (props: Props) => {
	return (
		<svg
			className={props.className}
			xmlns={"http://www.w3.org/2000/svg"}
			width={"34"}
			height={"25"}
			viewBox={"0 0 34 25"}
			fill={"none"}
		>
			<path
				d={
					"M5.58314 12.953V18.603L0 12.953V0.240479H22.3302L27.9133 5.8905H5.58314V12.953ZM27.9133 5.8905V18.603H5.58314L11.1663 24.2531H33.4965V11.5405L27.9133 5.8905Z"
				}
				fill={"#00296B"}
			/>
		</svg>
	)
}

export default DreamBrokerLogoWhiteSimple
